import styled from 'styled-components';

import { max } from '../../utils/breakpoints';

const StyledVerifyTitle = styled.div`
  text-align: left;
  margin-left: 90px;
  font-weight: bold;

  ${max.sm} {
    text-align: center;
    margin-left: 0;
  }
`;

export default StyledVerifyTitle;
